<!--
 * @Author: 半岛铁盒
 * @Date: 2021-11-01 19:22:58
-->
<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
  min-height: 100%;
}
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
ol,
ul {
  list-style-image: none;
  list-style-position: outside;
  list-style-type: none;
}
html,
body {
  width: 100%;
  height: 100%;
  min-height: 100%;
}
.font-big {
  font-size: 44px;
}
.font-middle {
  font-size: 22px;
}
.font-small {
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue